[
  {
    "name": "Article",
    "value": "Product"
  },
  {
    "name": "LAC",
    "value": "OrderLine"
  },
  {
    "name": "Lieu de livraison",
    "value": "DeliveryLocation"
  },
  {
    "name": "ShelfStatement",
    "value": "ShelfStatement"
  }
]